export default "__VITE_ASSET__b5Ad7W6m__"